import React, { useEffect, useState, useCallback } from "react";
import Layout from "../../../layouts/default";
import { FaUsers } from "react-icons/fa";
import { Button, Spinner, Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import {
  fetchAllDynamicAgentGroups,
  didAssignmentListStoreFiltersAndAgentGroup,
  resetDynamicAgentGroupState,
} from "../../../store/slices/smartConnect/dynamicAgentGroup";

function SmartConnectDidAssignment() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { dynamicAgentGroups, loading, error, didAssignmentList } = useSelector(
    (store) => store.dynamicAgentGroupReducer,
  );
  const { filters = {}, currentGroup = {} } = didAssignmentList;
  console.log("currentGroup : ", currentGroup);

  const [selectedGroupId, setSelectedGroupId] = useState(
    currentGroup?.id || null,
  );

  useEffect(() => {
    return () => {
      // reset ONLY if leaving did-assignments module
      if (!location.pathname.startsWith("/smart-connect/did-assignments")) {
        dispatch(resetDynamicAgentGroupState());
      }
    };
  }, [dispatch, location.pathname]);

  const fetchGroups = useCallback(() => {
    dispatch(fetchAllDynamicAgentGroups({ page: 1, limit: 50 }));
  }, [dispatch]);

  useEffect(() => {
    fetchGroups();
  }, [fetchGroups]);

  useEffect(() => {
    setSelectedGroupId(currentGroup?.id || null);
  }, [currentGroup]);

  useEffect(() => {
    if (dynamicAgentGroups?.length > 0 && !selectedGroupId) {
      const firstGroup = dynamicAgentGroups[0];

      setSelectedGroupId(firstGroup.id);

      navigate(`${firstGroup.id}`, {
        // replace: true,
        state: {
          groupId: firstGroup.id,
          groupName: firstGroup.group_name,
        },
      });
    }
  }, [dynamicAgentGroups, selectedGroupId, navigate]);

  const handleGroupClick = (group) => {
    setSelectedGroupId(group.id);
    navigate(`${group.id}`, {
      // replace: true,
      state: {
        groupId: group.id,
        groupName: group.group_name,
      },
    });

    // current gorup in redux
    dispatch(
      didAssignmentListStoreFiltersAndAgentGroup({
        filters: {},
        currentGroup: group,
      }),
    );
  };

  return (
    <Layout>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <FaUsers size={22} />
        <h3 style={{ margin: 0 }}>Agent DID Assignments</h3>
      </div>

      {loading && (
        <div className="text-center my-4">
          <Spinner animation="border" />
        </div>
      )}

      {error && (
        <Alert variant="danger" className="my-3">
          {error}
        </Alert>
      )}

      {!loading && !error && (
        <>
          {dynamicAgentGroups?.length > 0 && (
            <div
              style={{
                display: "flex",
                gap: 12,
                margin: "20px 0",
                flexWrap: "wrap",
              }}
            >
              {dynamicAgentGroups.map((group) => (
                <Button
                  key={group.id}
                  variant={
                    selectedGroupId === group.id
                      ? "secondary"
                      : "outline-secondary"
                  }
                  onClick={() => handleGroupClick(group)}
                >
                  {group.group_name}
                </Button>
              ))}
            </div>
          )}

          {dynamicAgentGroups?.length === 0 && (
            <div className="text-muted mt-4">
              No dynamic agent groups found.
            </div>
          )}

          {selectedGroupId && <Outlet context={{ groupId: selectedGroupId }} />}
        </>
      )}
    </Layout>
  );
}

export default SmartConnectDidAssignment;
